import { SLPcameraLang } from './slp/camera/camera.lang';
import { SLPFileLang } from './slp/file/file.lang';
import { SLPScoreRatingLang } from './slp/scoreRating/scoreRating.lang';
import { SLPVoiceLang } from './slp/voice/voice.lang';

export const utilitiesLang = {
    SLPrate: SLPScoreRatingLang,
    SLPCamera: SLPcameraLang,
    SLPFile: SLPFileLang,
    SLPVoice: SLPVoiceLang,
    SLPInputPH: 'پاسخ خود را بیان کنید',
    SLPInputPHEn: 'Give your answer',
    SLPDatePickerPH: 'جهت انتخاب تاریخ کلیک کنید',
    SLPDatePickerPHEn: 'Click to select a date',
    SLPDropDownPH: 'لطفا پاسخ خود را انتخاب کنید.',
    noItem: 'موردی یافت نشد.',
    SLPDropDownPHEn: 'Please select your answer.',
    SLPNumberPH: 'یک عدد وارد کنید',
    SLPNumberPHEn: 'Enter a number',
    SLPEmailPH: 'Example@gmail.com',
    SLPWebsitePH: 'www.Example.com',
    SLPPhonePH: '۰۰۰-۰۰۰۰۰۰۰۰',
    SLPPhonePHEn: '000-00000000',
    SLPMobilePH: '۰۰۰۰-۰۰۰-۰۰۰۰',
    SLPMobilePHEn: '0000-000-0000',
};
